/**
 * ReasoningStep — sibling row component for ReasoningPanel.
 *
 * Extracted from ReasoningPanel.jsx (Cluster I.D, Feb 2026) to satisfy
 * `react-hooks/static-components`. Renders one reasoning step row with
 * a semantic icon based on the step's event/content.
 */
import React from 'react';
import { Search, Brain, CheckCircle, Zap, Globe } from 'lucide-react';
import { cn } from '@/lib/utils';

function pickIconName(step) {
  const t = (step?.type || '').toLowerCase();
  const c = (step?.content || '').toLowerCase();
  if (t === 'source_found' || c.includes('retriev') || c.includes('hits')) return 'search';
  if (t === 'iteration_complete') return 'zap';
  if (t === 'decision' || c.includes('decid') || c.includes('routing')) return 'zap';
  if (c.includes('synthes') || c.includes('generat') || c.includes('writing')) return 'check';
  if (c.includes('web')) return 'globe';
  return 'brain';
}

function StepIcon({ name }) {
  // Static dispatch — no dynamic JSX tag, no static-components warning.
  if (name === 'search') return <Search className="w-3 h-3 text-[#7C5E3C]" />;
  if (name === 'zap')    return <Zap    className="w-3 h-3 text-[#7C5E3C]" />;
  if (name === 'check')  return <CheckCircle className="w-3 h-3 text-[#7C5E3C]" />;
  if (name === 'globe')  return <Globe  className="w-3 h-3 text-[#7C5E3C]" />;
  return <Brain className="w-3 h-3 text-[#7C5E3C]" />;
}

export default function ReasoningStep({ step, index, isArabic }) {
  const iconName = pickIconName(step);
  const content = step.content || '';

  return (
    <li
      className={cn('flex gap-2.5 items-start text-sm leading-relaxed', isArabic && 'flex-row-reverse text-right')}
      data-testid={`reasoning-step-${index}`}
    >
      <span className="mt-0.5 shrink-0 flex items-center justify-center w-5 h-5 rounded-full bg-[#F5F5F3] border border-black/10">
        <StepIcon name={iconName} />
      </span>
      <span className="text-[#1A1A1A]/85">{content}</span>
    </li>
  );
}
